<template>
    <div
        class="spinner-border text-primary"
        role="status"
    >
        <span class="sr-only">
            Laden
        </span>
    </div>
</template>

<script>
    export default {
        name: 'UiSpinner',
    };
</script>

<style lang="scss" scoped>
    .spinner-border {
        width: 1.5rem;
        height: 1.5rem;
    }
</style>
